import { IconArrowRight } from "@synthesis/shared-icons";
import { cn } from "@synthesis/shared-utils";
import { jsx, jsxs } from "react/jsx-runtime";
import { ContextMenu as ContextMenu$1 } from "@base-ui/react/context-menu";
import { Menu } from "@base-ui/react/menu";
//#region src/ContextMenu/index.tsx
const menuFocus = "outline-none focus:outline-none focus-visible:outline-none";
const ContextMenu = ({ state, children, onClick, disabled }) => {
	const handleOpenChange = (open) => {
		if (open) onClick?.();
	};
	const menuPopupClassName = cn("border-grey-300 z-50 w-auto min-w-72 max-w-full select-none rounded-lg border border-opacity-50 bg-white py-2 shadow-md backdrop-blur-sm backdrop-filter", menuFocus);
	const menuItemClassName = cn("hover:bg-neutrals-95 flex cursor-pointer items-center gap-4 p-3", menuFocus);
	const submenuTriggerClassName = menuItemClassName;
	const separatorClassName = "bg-grey-300 h-px";
	const renderMenuItems = (items) => {
		return items?.map((item, index) => {
			if (item.separator) return /* @__PURE__ */ jsx(Menu.Separator, { className: separatorClassName }, index);
			const handleClick = () => {
				item.onClick?.();
			};
			if (item.subItems && item.subItems.length > 0) return /* @__PURE__ */ jsxs(Menu.SubmenuRoot, { children: [/* @__PURE__ */ jsxs(Menu.SubmenuTrigger, {
				className: submenuTriggerClassName,
				children: [
					item.icon,
					item.label,
					/* @__PURE__ */ jsx(IconArrowRight, { className: "ml-auto size-4" })
				]
			}), /* @__PURE__ */ jsx(Menu.Portal, { children: /* @__PURE__ */ jsx(Menu.Positioner, {
				side: "right",
				align: "start",
				children: /* @__PURE__ */ jsx(Menu.Popup, {
					className: menuPopupClassName,
					children: renderMenuItems(item.subItems)
				})
			}) })] }, index);
			return /* @__PURE__ */ jsxs(Menu.Item, {
				"data-cy": "contextMenu-ContextMenuPrimitive-item",
				className: cn(menuItemClassName, item.activeRed && "text-type-error"),
				onClick: handleClick,
				disabled: item.disabled,
				children: [/* @__PURE__ */ jsx("span", {
					className: item.disabled ? "text-neutrals-60" : void 0,
					children: item.icon
				}), /* @__PURE__ */ jsx("span", {
					className: item.disabled ? "text-neutrals-60" : void 0,
					children: item.label
				})]
			}, index);
		});
	};
	return /* @__PURE__ */ jsxs(ContextMenu$1.Root, {
		disabled,
		onOpenChange: handleOpenChange,
		children: [/* @__PURE__ */ jsx(ContextMenu$1.Trigger, { render: (triggerProps) => /* @__PURE__ */ jsx("div", {
			...triggerProps,
			className: "h-full",
			children
		}) }), /* @__PURE__ */ jsx(ContextMenu$1.Portal, { children: /* @__PURE__ */ jsx(ContextMenu$1.Positioner, { children: /* @__PURE__ */ jsx(ContextMenu$1.Popup, {
			className: menuPopupClassName,
			children: renderMenuItems(state)
		}) }) })]
	});
};
//#endregion
export { ContextMenu };

//# sourceMappingURL=index.js.map